export { default } from './Footer24';
